import React, {FC, useLayoutEffect, useRef} from 'react';
import  ImageAttachment from 'botframework-webchat-component/lib/Attachment/ImageAttachment';
import { hooks } from 'botframework-webchat-component';



const { useActivities } = hooks;

/* eslint react/prop-types: "off" */
/* eslint react/require-default-props: "off" */

const ImageAttachmentWrapper: FC<{attachment, viewPictureHandler}> = ({attachment, viewPictureHandler}) => {
    const wrRef = useRef<HTMLDivElement>(null);
    useLayoutEffect(() => {

        // removed by MM: images are rendered with large dimmensions. leave as they are from bfv4. preview is available for fullscale image.

        // const imgDivWrapper = wrRef.current?.querySelector<HTMLDivElement>('div');
        
        // const imgElement = imgDivWrapper?.querySelector<HTMLImageElement>('img');
        // if(imgElement) {
        //     imgElement.style.position = 'relative';
        //     imgElement.style.left = "0";
        //     imgElement.style.top = "0";
        //     imgElement.style.transform = "none";
        // }
        
    }); 

    const [activities] = useActivities();
    const images = activities.filter(act => act.type === 'message' && act.attachments?.length)
                            .map(att => att.type === 'message' && att.attachments?.filter(fAtt => /^image\//u.test(fAtt.contentType)))
                            .flat();
    const idx = images.findIndex(att => att === attachment);

    return (
    <div className="druid-wrapper-ignore" ref={wrRef} onClick={() => viewPictureHandler(idx)} style={{cursor: 'pointer'}}>
        <ImageAttachment
              attachment={attachment}
            >
        </ImageAttachment>
    </div>);
}

export default ImageAttachmentWrapper;